{
  "authority": "https://genesis-bakery-auth.osmm.devtank.co.uk",
  "client_id": "osm-portal",
  "client_secret": "t00CTVgaDLH0wMD7UHmECvL1N3Z9G4pr",
  "apiUrl": "https://genesis-bakery-portal.osmm.devtank.co.uk/internal",
  "dbApi": "https://genesis-bakery-portal.osmm.devtank.co.uk/api",
  "dbToken": "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJyb2xlIjoiY3VzdG9tZXIifQ.-wXaanwb1SM8Tr0Q9Gu-erwozjM9CaDyyZYm-0aiQPY"
}
